import { getValue } from "../../../utils";

export function isEmpty(value) {
  if (value === null || value === undefined) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  if (Array.isArray(value) && value.length === 0) return true;

  if (typeof value === "object" && !Array.isArray(value)) {
    return Object.keys(value).length === 0;
  }

  return false;
}

export function isTrue(value) {
  return value === true || String(value).toLowerCase() === "true";
}

export function getBaseField(field = "") {
  return String(field || "").split(".")[0];
}

export function getNestedValue(obj, path = "") {
  if (!obj || !path) return undefined;

  return String(path)
    .split(".")
    .reduce((acc, key) => {
      if (acc && typeof acc === "object" && key in acc) {
        return acc[key];
      }

      return undefined;
    }, obj);
}

export function formatDetailValue(value) {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

export function formatDateValue(value) {
  if (!value) return "—";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return date.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function objectLabel(obj, column = {}) {
  if (!obj || typeof obj !== "object") return "";

  const keyPreferences = [
    column.apiTitle,
    "label",
    "name",
    "hazards",
    "tools",
    "machineTools",
    "equipments",
    "permitsType",
    "projectName",
    "siteLocation",
    "value",
    "title",
  ].filter(Boolean);

  for (const key of keyPreferences) {
    if (obj[key] !== undefined && obj[key] !== null) {
      return String(obj[key]);
    }
  }

  try {
    return JSON.stringify(obj);
  } catch {
    return String(obj);
  }
}

export function formatDisplayValue(value, column = {}) {
  if (value === null || value === undefined || value === "") return "—";

  if (column.type === "Date") {
    return formatDateValue(value);
  }

  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }

  if (typeof value === "object") {
    return objectLabel(value, column) || JSON.stringify(value);
  }

  return String(value);
}

export function dropdownLabelFromRow(row, column = {}) {
  const { field, options, apiTitle } = column;
  const baseField = getBaseField(field);
  const selected = row?.[baseField];

  if (selected && typeof selected === "object") {
    const nestedPath = String(field || "")
      .split(".")
      .slice(1)
      .join(".");

    return (
      (apiTitle && selected[apiTitle]) ||
      selected.name ||
      selected.label ||
      selected.title ||
      selected.value ||
      getNestedValue(selected, nestedPath) ||
      ""
    );
  }

  if (Array.isArray(options) && options.includes(selected)) {
    return selected;
  }

  const fullValue = getValue(row, field);
  if (typeof fullValue === "string" && fullValue.trim()) return fullValue;

  return selected || "";
}
